var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-12" }, [
    _c("div", { staticClass: "lecture row" }, [
      _vm.loading
        ? _c("div", { staticClass: "col-12 mt-5" }, [_vm._m(0)])
        : _c("div", { staticClass: "col-12 mt-3" }, [
            _vm.lecture && _vm.lecture.error && _vm.lecture.errorCode === 404
              ? _c("div", { staticClass: "error text-center" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.lecture.errorText))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "lead mb-5" }, [
                    _vm._v(_vm._s(_vm._f("translate")("No lecture found"))),
                  ]),
                  _vm._v(" "),
                  _vm.firstLecture
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          on: { click: _vm.goToFirstLecture },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("translate")(
                                  "Visit first lecture inside this course"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm.lecture &&
                _vm.lecture.error &&
                _vm.lecture.errorCode !== 401
              ? _c("div", { staticClass: "error text-center" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.lecture.errorText))]),
                ])
              : _vm.lecture &&
                _vm.lecture.error &&
                _vm.lecture.errorCode === 401
              ? _c("div", { staticClass: "mt-5 text-center bg-light p-5" }, [
                  _vm.htmlBlocks
                    ? _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.htmlBlocks) },
                      })
                    : _c("div", [
                        _c(
                          "svg",
                          {
                            staticClass: "feather feather-lock",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("rect", {
                              attrs: {
                                x: "3",
                                y: "11",
                                width: "18",
                                height: "11",
                                rx: "2",
                                ry: "2",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: { d: "M7 11V7a5 5 0 0 1 10 0v4" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "my-4" }, [
                          [
                            "Requires payment",
                            "Course requires payment",
                          ].includes(_vm.reason)
                            ? _c("h5", { staticClass: "fw-semibold" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("translate")(
                                        "This content is locked"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ])
                            : [
                                "Lecture requires login",
                                "Course requires login",
                              ].includes(_vm.reason)
                            ? _c("h5", { staticClass: "fw-semibold" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("translate")(
                                        "Sign up to see this content for free"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ])
                            : _vm.reason ===
                              "This lecture is not available in chosen variant"
                            ? _c("h5", { staticClass: "fw-semibold" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm._f("translate")(_vm.reason)) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm.isAuthenticated &&
                        [
                          "Requires payment",
                          "Course requires payment",
                        ].includes(_vm.reason)
                          ? _c("div", { staticClass: "my-4" }, [
                              _vm.course.is_free
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-primary px-4 m-3",
                                      attrs: {
                                        href: `/${_vm.$route.params.course}`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm._f("translate")("Enroll")
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : [
                                    "Requires payment",
                                    "Course requires payment",
                                  ].includes(_vm.reason)
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-dark px-4",
                                      attrs: {
                                        href: `/${_vm.$route.params.course}/checkout`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm._f("translate")("Buy now")
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : !_vm.isAuthenticated
                          ? _c(
                              "div",
                              [
                                _vm.course.is_free
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-primary px-4",
                                        attrs: {
                                          href: `/${_vm.$route.params.course}`,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm._f("translate")("Enroll")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : [
                                      "Requires payment",
                                      "Course requires payment",
                                    ].includes(_vm.reason)
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-dark px-4",
                                        attrs: {
                                          href: `/${_vm.$route.params.course}/checkout`,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm._f("translate")("Buy now")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "mx-3",
                                    attrs: {
                                      to: `/${_vm.$route.params.course}/watch/login`,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm._f("translate")("Sign in")) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.lecture &&
            _vm.lecture.components &&
            _vm.lecture.components.length &&
            !_vm.lecture.error
              ? _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _vm._l(_vm.lecture.components, function (component) {
                      return _c(
                        "div",
                        {
                          key: component.id,
                          staticClass: "row mb-2 d-flex justify-content-center",
                        },
                        [
                          _c(
                            "div",
                            { class: _vm.componentClasses(component.type) },
                            [
                              _c(_vm.componentName(component.type), {
                                ref: `component${component.id}`,
                                refInFor: true,
                                tag: "component",
                                attrs: { component: component },
                                on: {
                                  videoEnded: _vm.videoEnded,
                                  audioEnded: _vm.audioEnded,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.lecture
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "row mb-2 d-flex justify-content-center",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-11 py-3 text-center" },
                              [
                                _c("CompleteAndContinue", {
                                  ref: "completeAndContinue",
                                  staticClass: "btn btn-sm btn-dark",
                                  attrs: { size: "lg" },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.lecture && _vm.lecture.comments_module
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "row mb-2 d-flex justify-content-center",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-11 pt-3 rounded" },
                              [
                                _c("Comments", {
                                  attrs: { commentable: _vm.lecture },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm.lecture && !_vm.lecture.error
              ? _c("div", [
                  _c("div", { staticClass: "row mb-5" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "text-center py-5 bg-light" },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "feather feather-video-off",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "24",
                                  height: "24",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10",
                                  },
                                }),
                                _vm._v(" "),
                                _c("line", {
                                  attrs: {
                                    x1: "1",
                                    y1: "1",
                                    x2: "23",
                                    y2: "23",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "lead mt-4" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("translate")(
                                      "Oops... Nothing here at the moment"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 d-lg-none" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-10 offset-md-1" },
            [_c("MobileTabNav")],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading text-center pt-5" }, [
      _c("div", { staticClass: "spinner-border", attrs: { role: "status" } }, [
        _c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }